module.exports = __webpack_public_path__ + "static/media/test_seo_rules_upload.49ccc2cf.xlsx";